import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { ErrorMessage } from '@/shared/components/ErrorMessage';
import type { ICartBasket, TOrderTypes } from '@/shared/types/cart';

import { ordinalNumber } from '../../utils';
import Billing from './blocks/Billing';
import OrderTable from './blocks/OrderTable';
import PickUpOrder from './blocks/PickUpOrder';
import { Hr, StringNumberOfOrder, Wrapper } from './parts';

interface IProps {
  isSingle: boolean;
  basket: ICartBasket;
  basketIndex: number;
  orderTypes: TOrderTypes;
  numberOfOrders: number;
}

const OrderTile: FC<IProps> = ({ isSingle, basket, basketIndex, orderTypes, numberOfOrders }) => {
  const { formatMessage } = useIntl();

  const messages = {
    order: formatMessage({ id: 'Order' }),
  };
  const errorsComponent = basket.Errors?.map((errorText) => {
    return (
      <ErrorMessage id={basket.Id} key={errorText}>
        {errorText}
      </ErrorMessage>
    );
  });

  const numeric = ordinalNumber(basketIndex + 1);
  const orderNumber = `${numeric.charAt(0).toUpperCase() + numeric.slice(1)} ${messages.order}`;

  const stringNumberOfOrder = (
    <StringNumberOfOrder
      dangerouslySetInnerHTML={{
        __html: orderNumber,
      }}
    />
  );

  return (
    <Wrapper key={basket.Id}>
      {!isSingle && stringNumberOfOrder}
      <div id="basket-errors">{errorsComponent}</div>
      <PickUpOrder
        basket={basket}
        orderType={basket?.ProductType}
        orderTypes={orderTypes}
        orderNumber={orderNumber}
      />
      <OrderTable
        listItems={basket.LineItems}
        basketName={basket.Name}
        orderType={basket?.ProductType}
        orderTypes={orderTypes}
        productEditUrl={basket.BaseEditUrl}
      />
      <Billing
        isShowPayPalMessage={basket?.PayPalMessage}
        itemTotal={basket.ItemTotal}
        tax={basket.TaxTotal}
        handlingFee={basket.HandlingFee}
        fulfillment={basket.FulfillmentTotal}
        orderTotal={basket.OrderTotal}
        basketName={basket.Name}
        orderNumber={orderNumber}
      />
      <Hr isShow={basketIndex + 1 < numberOfOrders} />
    </Wrapper>
  );
};

export default OrderTile;
